import { useCallback } from "react";
import { logChatPromiseExecution } from "stream-chat";
import {
  defaultPinPermissions,
  MessageInput,
  MessageList,
  Thread,
  useChannelActionContext,
  Window,
} from "stream-chat-react";

import PinnedMessageList from "../PinnedMessageList/PinnedMessageList";
import TeamChannelHeader from "../TeamChannelHeader/TeamChannelHeader";

import { useGiphyInMessageContext } from "../../context/GiphyInMessageFlagContext";

export default function ChannelInner() {
  const { inputHasGiphyMessage, clearGiphyFlag } = useGiphyInMessageContext();
  const { sendMessage } = useChannelActionContext();

  // todo: migrate to channel capabilities once migration guide is available
  const teamPermissions = { ...defaultPinPermissions.team, user: true };
  const messagingPermissions = {
    ...defaultPinPermissions.messaging,
    user: true,
  };

  const pinnedPermissions = {
    ...defaultPinPermissions,
    team: teamPermissions,
    messaging: messagingPermissions,
  };

  const overrideSubmitHandler = useCallback(
    (message) => {
      const isReply = !!message.parent?.id;

      if (inputHasGiphyMessage(isReply)) {
        message.text = `/giphy ${message.text}`;
      }

      if (sendMessage) {
        const sendMessagePromise = sendMessage(message);
        logChatPromiseExecution(sendMessagePromise, "send message");
        clearGiphyFlag(isReply);
      }
    },
    [inputHasGiphyMessage, sendMessage, clearGiphyFlag],
  );

  return (
    <>
      <Window>
        <TeamChannelHeader />
        <MessageList disableQuotedMessages pinPermissions={pinnedPermissions} />
        <MessageInput overrideSubmitHandler={overrideSubmitHandler} />
      </Window>
      <Thread
        additionalMessageInputProps={{
          Input: MessageInput,
          overrideSubmitHandler,
        }}
      />
      <PinnedMessageList />
    </>
  );
}
